// extracted by mini-css-extract-plugin
export var blankSep = "challenge-module--blankSep--22e7f";
export var breadcrumbs = "challenge-module--breadcrumbs--09712";
export var pattern = "challenge-module--pattern--10862";
export var sep = "challenge-module--sep--01109";
export var simpleSep = "challenge-module--simpleSep--91b8b";